import { SUPPORT_FORM_URL, DEMO_FORM_URL } from '../config'

const openForm = (url) => {
	  window.open(url, '_blank', 'noopener,noreferrer')
};

export const openSupportForm = () => {
	openForm(SUPPORT_FORM_URL)
}

export const openDemoForm = () => {
	openForm(DEMO_FORM_URL)
}

export const openSupportEmail = openSupportForm
